import React, {Fragment, useMemo} from "react";
import {compose} from "redux";
import {translate} from "react-i18next";
import {Col, Row} from "antd";
import UnionQueryColumns from "./UnionQueryColumns";
import {GUTTER_MD, SPAN_ONE_THIRD, SPAN_TWO_THIRDS} from "../../../../../styles/constants";
import UnionQueryFilters from "./UnionQueryFilters";
import UnionAlert from "./UnionAlert";
import {connect} from "react-redux";

const mapStateToProps = state => {
    return {
        selectedTables: state.scenes.mappingHandler.datasetBuilder.unionModalProps.selectedTables,
        aliasCols: state.scenes.mappingHandler.datasetBuilder.unionModalProps.aliasCols,
        currentlySelectedTable: state.scenes.mappingHandler.datasetBuilder.unionModalProps.currentlySelectedTable,
    }
};

const UnionQuery = ({t, selectedTables, aliasCols, currentlySelectedTable}) => {
    const selectedTablesNotCurrentlySelected = useMemo(() => {
        if (!selectedTables) {
            return []
        }
        if (!currentlySelectedTable.id) {
            return selectedTables;
        }
        return selectedTables.filter(item => item.id !== currentlySelectedTable.id)
    }, [selectedTables, currentlySelectedTable]);

    const totalLengthOfSelects = useMemo(() => [
            ...(new Set([(aliasCols || []).length,
                ...(selectedTablesNotCurrentlySelected || []).map(table => table.aliasCols.length)]))].length,
        [aliasCols, selectedTablesNotCurrentlySelected]);

    return (
        <Fragment>
            <UnionAlert
                forceFromExternalCondition={selectedTablesNotCurrentlySelected.length > 0 &&
                    aliasCols.length > 0 &&
                    totalLengthOfSelects > 1
                }
                customMessage={t("data.datasetBuilder.possibleMismatchUnionWarning")}/>
            <Row type="flex" gutter={GUTTER_MD} style={{height: "100%"}}>
                <Col span={SPAN_ONE_THIRD} style={{display: 'flex'}}>
                    <UnionQueryColumns/>
                </Col>
                <Col span={SPAN_TWO_THIRDS}>
                    <UnionQueryFilters/>
                </Col>
            </Row>
        </Fragment>
    )
}

export default compose(
    translate(),
    connect(mapStateToProps),
)(UnionQuery);